/*@flow*/
import * as t from 'lib/t';

export default t.subtype(t.String, v => v && v.trim() !== '');
